<template>
  <Marker :options="options" @click="onClick">
    <InfoWindow ref="infoWindowRef" :options="infoWindowOptions" v-if="renderInfoWindow">
      <EcoEventsInfo :description="fuelCapOpenLabel" :data="infoOptions" />
    </InfoWindow>
  </Marker>
</template>

<script>
import {InfoWindow, Marker} from "vue3-google-map";
import {dataManipulator} from "@/assets/js/data-manipulation";
import markerIcon from '@/assets/images/reports/fuelcap-marker.png';
import EcoEventsInfo from "@/components/pages/EcoEventsInfo.vue";

export default {
  name: "FuelCapOpenMarker",
  components: {EcoEventsInfo, InfoWindow, Marker},
  props: {
    data: {
      type: Object,
      required: true
    },
    infoWindowHeader: {
      type: Object,
      required: true
    },
    openInfoOnClick: {
      type: Boolean,
      default: true
    },
    customOptions: Object,
  },
  emits: ['click'],
  data() {
    return {
      renderInfoWindow: false,
    };
  },
  computed: {
    options() {
      return {
        ...{
          position: this.position,
          icon: markerIcon,
        },
        ...this.customOptions
      };
    },
    infoWindowOptions() {
      return {
        position: this.position,
        headerContent: this.infoWindowHeader
      };
    },
    infoOptions() {
      return {
        address: this.address,
        time: this.time,
      }
    },
    position() {
      return {lat: this.data.lat, lng: this.data.lng};
    },
    address() {
      return `${this.data.lat}, ${this.data.lng}`;
    },
    time() {
      const data = dataManipulator.iso8601DateStringToLocalMoment(this.data.timestamp);
      return data !== null ? data.format(this.$t('settings.generic.date-time-format-moment')) : ''
    },
    fuelCapOpenLabel() {
      return this.$t('reports.trips.result.fuelCapOpen');
    }
  },
  methods: {
    onClick() {
      this.$emit('click', this);
      if (this.openInfoOnClick) {
        this.showInfoWindow();
      }
    },
    showInfoWindow() {
      this.renderInfoWindow = true;
      setTimeout(() => this.$refs.infoWindowRef?.open(), 10);
    },
    closeInfoWindow() {
      this.$refs.infoWindowRef?.close();
      this.renderInfoWindow = false;
    },
    isInfoWindowOpen() {
      return this.$refs.infoWindowRef?.infoWindow.isOpen;
    }
  }
}
</script>

<style scoped lang="scss">

</style>